import * as sentry from '@sentry/angular';

import { getApiErrorMessage } from '../shared/errors';
import { environment } from '../../environments/environment';

/**
 * Initialize right away to catch any startup errors.
 * Once we get feature flags, Sentry may be disabled or reinitialized to track sessions.
 */
// initializeSentry();

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function initializeSentry(): void {
  sentry.init({
    environment: window.location.hostname,
    release: `flywheel-frontend@${environment.package_version}`,
    dsn: 'https://81e4bb1d4268485cb642431ac85caa25@sentry.io/2134645',
    ignoreErrors: [
      'TypeError: Failed to fetch',
      'TypeError: NetworkError when attempting to fetch resource.',
      'TypeError: cancelled',
      'TypeError: Cancelled',
      'message: cancelled',
      'cancelled',
    ],
    integrations: [
      sentry.browserTracingIntegration(),
      sentry.replayIntegration(),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    tracePropagationTargets: [window.location.host], // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    // Session Replay
    replaysSessionSampleRate: 0.2, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
  
}

export function getError(error): Error {
  if (error instanceof Error) {
    return error;
  }
  if (typeof error === 'string') {
    return new Error(error);
  }
  const apiMessage = getApiErrorMessage(error);
  return Object.assign(new Error(), error, apiMessage ? { message: apiMessage } : {});
}